var React = require('react');

function IconCharge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"#fff","d":"M650.403 501.313c-3.728-15.728-15.272-28.365-30.59-33.452l-228.359-76.135 162.181-324.356c10.179-20.408 4.087-45.226-14.41-58.59-18.59-13.318-44.046-11.317-60.137 4.862l-465.445 465.446c-11.41 11.408-16.092 27.909-12.409 43.59 3.727 15.723 15.273 28.365 30.589 33.452l228.359 76.134-162.179 324.357c-10.181 20.406-4.090 45.224 14.41 58.591 18.528 13.275 43.932 11.334 60.135-4.864l465.445-465.445c11.408-11.408 16.091-27.909 12.409-43.59z","key":1})]);
}

IconCharge.defaultProps = {"version":"1.1","width":"652","height":"1024","viewBox":"0 0 652 1024"};

module.exports = IconCharge;

IconCharge.default = IconCharge;
